import { DEFAULT_PRINTABLE_BOOKING_FEE_PERCENTAGE } from '@rover/constants/src/translations/service.constants';
import { Link, Paragraph } from '@rover/kibble/core';
import { getBookingFeeLearnMoreUrl } from '@rover/react-lib/src/utils/bookingFeeUtils';
import { useCurrentCountryConfiguration } from '@rover/rsdk/src/modules/Data/Core/CountryConfiguration';
import getUserAgentFlags from '@rover/shared/js/utils/getUserAgentFlags';

export type Props = {
  leadingText?: string;
};

export default function PriceTransparencyNotice({ leadingText = 'Includes' }: Props): JSX.Element {
  const { data: countryConfig } = useCurrentCountryConfiguration();
  const bookingFeePercentage =
    countryConfig?.bookingFeePercentage ?? DEFAULT_PRINTABLE_BOOKING_FEE_PERCENTAGE;
  const bookingFeeWebLink = getBookingFeeLearnMoreUrl(countryConfig?.urls);
  const bookingFeeDeeplink = `rover://web/?url=${encodeURIComponent(
    bookingFeeWebLink
  )}&target=system`;
  const { isEmbedded } = getUserAgentFlags();

  // TODO (DEV-104195): Translate text in this component
  return (
    <Paragraph
      textColor="tertiary"
      size="200"
      webProps={{ display: 'flex' }}
      m="0x"
      sx={{ gap: '1x' }}
    >
      {leadingText} {bookingFeePercentage}
      <Link
        href={isEmbedded ? bookingFeeDeeplink : bookingFeeWebLink}
        fontWeight="semibold"
        variant="secondary"
        target={isEmbedded ? undefined : '_blank'}
        rel="noopener noreferrer"
      >
        booking fee
      </Link>
    </Paragraph>
  );
}
